"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var events_1 = require("../viewUtils/events");
var model_1 = require("../diagram/model");
// bundling jstree to solve issues with multiple jquery packages,
// when jstree sets itself as plugin to wrong version of jquery
var jstreeJQuery = require('exports-loader?require("jquery")!jstree');
require('jstree/dist/themes/default/style.css');
var CLASS_NAME = 'ontodia-class-tree';
var ClassTree = /** @class */ (function (_super) {
    tslib_1.__extends(ClassTree, _super);
    function ClassTree() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.listener = new events_1.EventObserver();
        _this.onSearchKeyup = function (e) {
            var searchString = e.currentTarget.value;
            _this.jsTree.jstree('search', searchString);
        };
        _this.onTreeRootMount = function (treeRoot) {
            _this.treeRoot = treeRoot;
            _this.jsTree = jstreeJQuery(_this.treeRoot);
        };
        return _this;
    }
    ClassTree.prototype.componentDidMount = function () {
        var _this = this;
        this.jsTree.jstree({
            'plugins': ['types', 'sort', 'search'],
            'sort': function (firstClassId, secondClassId) {
                var first = this.get_node(firstClassId);
                var second = this.get_node(secondClassId);
                return first.text.localeCompare(second.text);
            },
            'search': {
                'case_insensitive': true,
                'show_only_matches': true,
            },
        });
        this.refreshClassTree();
        this.jsTree.on('select_node.jstree', function (e, data) {
            var onClassSelected = _this.props.onClassSelected;
            onClassSelected(data.selected[0]);
        });
        var _a = this.props, view = _a.view, editor = _a.editor;
        this.listener.listen(view.events, 'changeLanguage', function () { return _this.refreshClassTree(); });
        this.listener.listen(editor.model.events, 'changeClassTree', function () {
            _this.refreshClassTree();
        });
    };
    ClassTree.prototype.componentWillUnmount = function () {
        this.listener.stopListening();
    };
    ClassTree.prototype.render = function () {
        return (React.createElement("div", { className: CLASS_NAME },
            React.createElement("div", { className: CLASS_NAME + "__filter" },
                React.createElement("div", { className: CLASS_NAME + "__filter-group" },
                    React.createElement("input", { type: 'text', className: 'search-input ontodia-form-control', placeholder: 'Search for...', defaultValue: '', onKeyUp: this.onSearchKeyup }))),
            React.createElement("div", { className: CLASS_NAME + "__rest" },
                React.createElement("div", { ref: this.onTreeRootMount, className: CLASS_NAME + "__tree" }))));
    };
    ClassTree.prototype.refreshClassTree = function () {
        var _a = this.props, view = _a.view, editor = _a.editor;
        var iconMap = {
            'default': { icon: 'default-tree-icon' },
            'has-not-children': { icon: 'default-tree-icon' },
            'has-children': { icon: 'parent-tree-icon' },
        };
        var roots = editor.model.getClasses().filter(function (model) { return !model.base; });
        var mapped = roots.map(function (root) { return mapClass(root, view, iconMap); });
        var jsTree = this.jsTree.jstree(true);
        jsTree.settings.core.data = mapped;
        jsTree.settings.types = iconMap;
        jsTree.refresh(/* do not show loading indicator */ true, undefined);
    };
    return ClassTree;
}(React.Component));
exports.ClassTree = ClassTree;
function mapClass(classModel, view, iconMap) {
    var id = classModel.id, label = classModel.label, count = classModel.count, derived = classModel.derived;
    var children = derived.map(function (child) { return mapClass(child, view, iconMap); });
    var icon = view.getTypeStyle([id]).icon;
    var classLabel = model_1.formatLocalizedLabel(id, label, view.getLanguage());
    var text = classLabel + (typeof count === 'number' ? " (" + count + ")" : '');
    var type = children.length > 0 ? 'has-children' : 'has-not-children';
    return {
        id: id,
        label: label,
        count: count,
        children: children,
        a_attr: {
            href: id,
            draggable: true,
            title: classLabel + " " + view.formatIri(id),
        },
        text: text,
        type: type,
        icon: icon,
    };
}
exports.default = ClassTree;
